<template>
  <section >
    <div class="p-8 py-2 pt-2">
      <div class="flex justify-between md:justify-start items-center gap-10">
        <p class="font-bold text-lg py-4 flex gap-3 items-center">
          <span>{{ $t("chapters.title") }}</span>
          <button
            v-if="role == 'TEACHER' && data.adaptive"
            v-tooltip.bottom="{
              value: `Clique primeiro em “Adicionar Capítulo”, depois clique em “Adicionar Objetivo” e complete o grafo de conteúdo do curso.`,
              class: 'text-center',
            }"
            class="cursor-default"
          >
            <v-icon name="hi-information-circle" />
          </button>
        </p>
        <Button
          v-if="role == 'TEACHER'"
          icon="pi pi-plus"
          :label="$t('chapters.add')"
          class="btn-primary p-button-sm"
          @click="goToChapter()"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { GoToRoute } from "@/utils/go-to.util";
import { defineComponent } from "vue";

export default defineComponent({
  name: "topbar",
  emits: ["openAdaptiveChapter"],
  props: {
    data: { type: Object, default: {} },
    role: [String],
  },
  computed: {
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  methods: {
    goToChapter(): void {
      if (this.data.adaptive) {
        this.$emit("openAdaptiveChapter");
      } else {
        this.go.redirectToPage("formChapterTraditional", {
          courseId: this.data.id,
          tab: 0,
        });
      }
    },
  },
});
</script>
